import { Box, Container, SxProps, Theme } from "@mui/material";
import { ElementType, PropsWithChildren } from "react";
export default function PageWrapper({
  children,
  sx,
  component,
}: { component?: ElementType<any, keyof JSX.IntrinsicElements>; sx?: SxProps<Theme> | undefined } & PropsWithChildren) {
  return (
    <Container
      maxWidth={"xl"}
      sx={{
        px: {
          xs: 0.5,
          xsm: 1,
          sm: 2,
        },
        overflowX: "clip",
        ...sx,
      }}
      {...(component && { component: component })}
    >
      {children}
    </Container>
  );
}
